import { React } from "react";
import { Col, Row } from "reactstrap";
import { Selectform } from "../../components/drop_down/Selectform";

export function MaterialSetting({
  formData,
  data,
  handleInputChange,
  IsGenerating,
}) {
//   let hideThemeField = false;
//   let hideGrammarField = false;
//   let hideQuestionField = false;
//   let hideOptionField = false;
//   let hideVoiceField = false;

//   if (data && data?.disable_fields_for_template) {
//     hideThemeField = data?.disable_fields_for_template?.includes(
//       disbaleFields.THEME
//     );
//     hideGrammarField = data?.disable_fields_for_template?.includes(
//       disbaleFields.GRAMMAR
//     );
//     hideVoiceField = data?.disable_fields_for_template?.includes(
//       disbaleFields.SAMPLE_VOICES
//     );
//     hideQuestionField = data?.disable_fields_for_template?.includes(
//       disbaleFields.NO_OF_QUESTIONS
//     );
//     hideOptionField = data?.disable_fields_for_template?.includes(disbaleFields.NO_OF_OPTIONS) ||
//                       formData?.question_type === "FillInBlank" ||
//                       formData?.question_type === "DragAndDropCrossMatch";
//   }

//   if (
//     data && data?.task_type !== exerciseType.LISTENING_TASK &&
//     hideThemeField &&
//     hideGrammarField &&
//     hideQuestionField &&
//     hideOptionField
//   ) {
//     return null;
//   }
//   else if (
//     data && data?.task_type === exerciseType.LISTENING_TASK &&
//     hideThemeField &&
//     hideGrammarField &&
//     hideQuestionField &&
//     hideOptionField &&
//     hideVoiceField
//   ) {
//     return null;
//   }
  return (
    <Row className="g-0 pt-3">
        <>
          <Row className="col-12 g-0">
            {/* {!hideThemeField && ( */}
              <div className="col-12 p-2 pb-1">
                <label class="pb-2 fw-600" for="topic">
                 Age group
                </label>
                <div class="form-group md-group show-label">
                    <Selectform
                        name="age_group"
                        placeholder={"Select age group"}
                        selectedvalue={formData.age_group}
                        choices={data?.group_age_choices}
                        onChange={handleInputChange}
                        disabled={IsGenerating}
                        required
                    />
                </div>
              </div>
            {/* )} */}
            {/* {!hideGrammarField && ( */}
              <div className="col-12 p-2 pb-1">
                  <label class="pb-2 fw-600" for="level">
                   Level
                  </label>
                <div class="form-group md-group show-label">
                    <Selectform
                        name="level"
                        placeholder={"Select level"}
                        selectedvalue={formData.level}
                        choices={data?.level_choices}
                        onChange={handleInputChange}
                        disabled={IsGenerating}
                        required
                    />
                </div>
              </div>
            {/* )} */}
            <div className="col-12 p-2 pb-1">
              <label class="pb-2" for="learning">
                Learning objective
                <span class="custom_tooltip">
                  <span class="ps-1">
                  <svg width="15" height="15" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="6.5" cy="6.5" r="4.875" stroke="#4A5567" stroke-width="1.625"/>
                    <path d="M6.77116 4.06283C6.77116 4.2124 6.6499 4.33366 6.50033 4.33366C6.35075 4.33366 6.22949 4.2124 6.22949 4.06283C6.22949 3.91325 6.35075 3.79199 6.50033 3.79199C6.6499 3.79199 6.77116 3.91325 6.77116 4.06283Z" fill="#4A5567" stroke="#4A5567" stroke-width="0.8125"/>
                    <path d="M6.5 9.20866V5.41699" stroke="#4A5567" stroke-width="1.625"/>
                  </svg>
                  </span>
                </span>
              </label>
              <Col className="col-12">
                <div class="col-12">
                  <div class="col-12 p-3 ps-0">
                    <div class="mb-3">
                      <textarea
                        class="form-control sm-form-rounded py-2"
                        name="objective"
                        rows="5"
                        cols="97"
                        placeholder="Make the task about popular foods around the world. Include all types of cuisines."
                        value={formData.objective}
                        onChange={handleInputChange}
                        disabled={IsGenerating}
                        required
                      ></textarea>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </Row>
        </>
    </Row>
  );
}
